import styled from '@mui/material/styles/styled';

export const Root = styled('div')({
  flexGrow: 1,
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end'
});

export const MessagesContainer = styled('div')(({ theme }) => ({
  width: '100%',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: '24px',
  padding: '30px 30px 90px 30px',
  ...theme.scrollbars.default
}));

export const InputContainer = styled('div')({
  flexShrink: 0,
  width: '100%',
  position: 'absolute',
  bottom: 0,
  overflow: 'hidden',
  padding: '16px',
});